module.exports = __webpack_public_path__ + "media/images/hr/dot_full-542dbd40ea5a8db6ead445e9fef77e72.svg";